import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SoundOff = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M5.769 8.587H2.952a.96.96 0 0 0-.952.97v6.303c0 .535.426.97.952.97H5.77a.94.94 0 0 1 .513.152L12 20.708v-16L6.282 8.434a.94.94 0 0 1-.513.153'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='m22 10.208-2.5 2.5m0 0-2.5 2.5m2.5-2.5-2.5-2.5m2.5 2.5 2.5 2.5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <path
        d='M11.68 4.03a.75.75 0 0 1 1.07.678v16a.75.75 0 0 1-1.16.628L5.874 17.61a.2.2 0 0 0-.104-.031H2.952a1.71 1.71 0 0 1-1.702-1.72V9.556c0-.937.75-1.72 1.702-1.72H5.77q.054 0 .104-.03l5.718-3.726zm9.846 5.596a.75.75 0 0 1 1.056 1.055l-.052.057-1.97 1.97 1.97 1.97.052.056a.75.75 0 0 1-1.056 1.056l-.056-.052-1.97-1.97-1.97 1.97a.75.75 0 0 1-1.06-1.06l1.97-1.97-1.97-1.97-.052-.057a.75.75 0 0 1 1.056-1.055l.056.051 1.97 1.97 1.97-1.97z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
